import {Component, Input, Output, EventEmitter, Pipe, PipeTransform, ViewChild, HostListener} from '@angular/core';
import {OpenAPIService} from '../services/openapi';
import {SecretService} from '../services/secret';
import {UtilsService} from '../services/utils';

declare let window:any;
declare let $:any;

@Pipe({
    name: 'parameterFilter',
})
export class ParameterFilterPipe implements PipeTransform {
  transform(items: any[], args: any[]): any {
    let field = args[0];
    let value = args[1];
    return items.filter(item => {
      return item[field] == value;  // Truthy ==
    });
  }
}

@Component({
  selector: 'parameter-set',
  templateUrl: '../views/parameter-set.pug',
  styles: [`
    .global-parameters {
      padding-left: 15px;
    }
  `],
})
export class ParameterSetComponent {
  @Input() parameterSet;
  @Input() groups;
  @Input() answers;
  @Input() view;
  @Output() valueChange = new EventEmitter();

  hasGlobal:boolean;

  constructor(private openapi:OpenAPIService, private utils:UtilsService) {
  }

  ngOnChanges() {
    this.hasGlobal = !!this.parameterSet.filter(p => p.global).length || window.config.uiOptions.optionalizeHost;
  }
}

@Component({
    selector: 'parameter',
    templateUrl: '../views/parameter.pug',
})
export class ParameterComponent {
  @Input('parameter') inputParameter;
  parameter:any;
  @Input() model;
  @Input() view;
  @Input() hideTextEditor;
  @Input() hideLabel;
  @Input() depth;
  @Input() fillFromSecrets;
  @Input() readOnly:boolean;
  @Output() valueChange = new EventEmitter();
  contentType:string;
  objectArray:any[] = [];
  JSON = JSON;

  inputType:string;

  marked:any = window.marked;

  error:string;
  refreshingEnum:boolean;

  filename:string;

  subscriptions:any[] = [];

  constructor(private openapi:OpenAPIService, private secrets:SecretService, private utils:UtilsService) {
  }

  ngOnChanges() {
    if (!this.parameter || this.parameter.name !== this.inputParameter.name) {
      this.parameter = this.inputParameter;
    } else {
      Object.assign(this.parameter, this.inputParameter);
    }
    this.openapi.replaceXValues(this.parameter);
  }

  ngOnDestroy() {
    this.subscriptions.forEach(s => s.unsubscribe());
  }

  ngOnInit() {
    if (this.view === 'documentation') return;
    this.inputType = this.getBestInputType();
    if (this.model[this.parameter.name] === undefined) {
      let val = undefined;
      if (this.fillFromSecrets && this.secrets.secrets[this.parameter.name] !== undefined) {
        val = this.secrets.secrets[this.parameter.name];
      } else if (this.parameter.consoleDefault !== undefined) {
        val = this.parameter.consoleDefault;
      } else if (this.parameter.default !== undefined) {
        val = this.parameter.default;
      }
      if (val !== undefined && this.showConditionMet()) {
        this.model[this.parameter.name] = val;
        this.onChange();
      }
      if (this.parameter.type === 'array' && !this.model[this.parameter.name]) {
        this.model[this.parameter.name] = [];
      }
    }
    if (this.fillFromSecrets) {
      this.subscriptions.push(this.secrets.onChange.subscribe(newSecrets => {
        if (newSecrets[this.parameter.name] !== undefined) {
          this.model[this.parameter.name] = newSecrets[this.parameter.name];
          this.onChange();
        }
      }));
    }
    if (this.parameter.in === 'body' && (this.parameter.consumes || []).indexOf('application/json') !== -1) {
      let startval = this.model[this.parameter.name];
      this.setContentType('application/json');
    } else if (this.parameter.in === 'body' && this.parameter.consumes) {
      this.setContentType(this.parameter.consumes[0]);
    }
  }

  trackByIndex(idx) {
    return idx;
  }

  onChange() {
    if (this.inputType === 'text' && !this.model[this.parameter.name]) {
      delete this.model[this.parameter.name];
    }
    this.valueChange.emit(this.model[this.parameter.name]);
  }

  setContentType(t) {
    this.parameter.contentType = this.contentType = t;
    delete this.model[this.parameter.name];
  }

  showConditionMet() {
    if (!this.parameter.showCondition) return true;
    let cond = this.parameter.showCondition;
    return cond.value.indexOf(this.model[cond.name]) !== -1;
  }

  iterateObject(obj) {
    return Object.keys(obj).map(k => ({key: k, value: obj[k]}));
  }

  getBestInputType() {
    if (this.parameter.inputType) return this.parameter.inputType;
    var type = this.parameter.type;
    if (this.parameter.in === 'body') {
      return 'body';
    } else if (type === 'array') {
      if (this.parameter.items.type === 'object') return 'objectArray';
      if (this.parameter.enum || this.parameter.items.enum) {
        return 'checkboxes';
      } else {
        return 'dynamicArray';
      }
    } else if (this.parameter.enum || this.parameter.dynamicEnum) {
      return 'dropdown';
    } else if (type === 'boolean') {
      return 'boolean';
    } else if (type === 'number' || type === 'integer') {
      return 'number';
    } else if (type === 'file') {
      return 'file';
    }
    return 'text';
  }

  formatDatetime(date) {
    if (window.lucybot.formatDatetime) {
      this.model[this.parameter.name] = window.lucybot.formatDatetime(date);
    } else {
      this.model[this.parameter.name] = date.getTime();
    }
  }

  fileChange(evt) {
    var files = (evt.srcElement || evt.target).files;
    this.model[this.parameter.name] = files[0];
    if (files[0]) this.filename = files[0].name;
  }

  getValueFromAPI(dyn, cb) {
    var answers = {};
    (dyn.parameters || []).forEach((p) => {
      if (p.value.answer) {
        answers[p.name] = this.model[p.value.answer];
      } else {
        answers[p.name] = p.value;
      }
    })
    this.openapi.request({
      swagger: this.openapi.parsed,
      path: dyn.path,
      method: dyn.method,
      answers: answers,
      embed: true,
    })
    .done((data, textStatus, xhr) => {
      if (!window.checkResponse) return cb(data);
      var resp = window.checkResponse(data, xhr.status);
      if (resp.type === 'success') return cb(data);
      this.error = resp.message;
      cb();
    })
    .fail((xhr) => {
      this.error = xhr.responseText;
      cb();
    })
  }

  refreshEnum() {
    this.error = null;
    let dynEnum = this.parameter.dynamicEnum;
    if (!dynEnum) return;
    let setEnum = (data) => {
      if (!data) return;
      var arr = this.utils.followPath(data, dynEnum.array);
      this.parameter.enum = arr.map((choice) => {
        return this.utils.followPath(choice, dynEnum.value);
      });
      this.parameter.enumLabels = arr.map((choice) => {
        return this.utils.followPath(choice, dynEnum.label);
      });
      this.refreshingEnum = false;
    }
    this.refreshingEnum = true;
    this.getValueFromAPI(dynEnum, setEnum);
  }

  getCollectionFormatMessage(param) {
    if (param.collectionFormat === 'multi') {
      return 'Values should be specified as separate query parameters';
    }
    var ret = 'Values should be joined by ';

    if (param.collectionFormat === 'csv') {
      return ret + 'commas.';
    } else if (param.collectionFormat === 'ssv') {
      return ret + 'spaces.';
    } else if (param.collectionFormat === 'tsv') {
      return ret + 'tabs.';
    } else if (param.collectionFormat === 'pipes') {
      return ret + 'pipes.';
    }
  }

  objectArrayChange(evt) {
    let addToModel = (key, val) => {
      if (Array.isArray(val)) {
        val.forEach((v, idx) => {
          addToModel(key + '[' + idx + ']', v);
        })
      } else if (typeof val === 'object') {
        for (let subkey in val) {
          addToModel(key + '[' + subkey + ']', val[subkey]);
        }
      } else {
        this.model[key] = val;
      }
    }
    for (let key in this.model) {
      if (key.indexOf(this.parameter.name) === 0) delete this.model[key];
    }
    addToModel(this.parameter.name, this.objectArray.map(a => JSON.parse(a.value || '{}')));
    this.onChange();
  }
}

const checkForMembers = (params, group) => {
  if (params.filter(p => p.group === group.name).length) return true;
  if (group.subGroups) {
    let subgroupHasMembers = group.subGroups.filter(g => checkForMembers(params, g)).length;
    if (subgroupHasMembers) return true;
  }
  return false;
}

@Component({
    selector: 'parameter-group',
    templateUrl: '../views/parameter-group.pug',
    styles: [`
      .parameters {
        padding-left: 15px;
      }
    `],
})
export class ParameterGroupComponent {
  @Input() group;
  @Input() parameterSet;
  @Input() model;
  @Input() view;
  @Output() valueChange = new EventEmitter();
  @Input() visible:boolean;
  hasMembers:boolean;
  marked:any = window.marked;

  ngOnChanges() {
    this.hasMembers = checkForMembers(this.parameterSet, this.group);
  }
}



// WEBPACK FOOTER //
// ./src/app/components/parameter.ts